'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getBrowserHandoffEnvironment } from '@/lib/desktop-handoff/environment';

/** Whether the browser is prerendering this page; it flips once the person actually opens it. */
export function useIsPrerendering() {
  const $ = _c(3);
  const [isPrerendering, setIsPrerendering] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== isPrerendering) {
    t0 = () => {
      if (!isPrerendering) {
        return;
      }
      const activate = () => setIsPrerendering(false);
      document.addEventListener("prerenderingchange", activate, {
        once: true
      });
      return () => document.removeEventListener("prerenderingchange", activate);
    };
    t1 = [isPrerendering];
    $[0] = isPrerendering;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isPrerendering;
}
function _temp() {
  return getBrowserHandoffEnvironment().isPrerendering;
}